__turbopack_context__.v({
  "accordianContainer": "vJ55jG_accordianContainer",
  "buttonFocused": "vJ55jG_buttonFocused",
  "hoverEnabled": "vJ55jG_hoverEnabled",
});
